module.exports = __webpack_public_path__ + "media/src/web/images/home/heroimg_bg-5d8a231be3c4f559ba25e91a632f9543.png";